import { jsx as l } from "react/jsx-runtime";
const i = (a) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentcolor",
        fillRule: "evenodd",
        d: "M2 16C2 8.268 8.268 2 16 2a6 6 0 0 1 6 6c0 7.732-6.268 14-14 14a6 6 0 0 1-6-6m3.172 2.828a4 4 0 0 1-1.144-2.352 9.6 9.6 0 0 1 2.295.995c1.01.606 1.459 1.66 1.626 2.529a4 4 0 0 1-2.777-1.172M18.828 5.172a4 4 0 0 1 1.166 2.617c-.74-.241-1.633-.666-2.402-1.365-.809-.736-1.29-1.662-1.552-2.424a4 4 0 0 1 2.788 1.172m-3.12 3.12a1 1 0 0 0-1.415 0L13 9.587l-.293-.293a1 1 0 1 0-1.414 1.414l.293.293-.586.586-.293-.293a1 1 0 0 0-1.414 1.414l.293.293-1.293 1.293a1 1 0 1 0 1.414 1.414L11 14.414l.293.293a1 1 0 0 0 1.414-1.414L12.414 13l.586-.586.293.293a1 1 0 0 0 1.414-1.414L14.414 11l1.293-1.293a1 1 0 0 0 0-1.414",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  i as default
};
